import { getMarkup } from "./services/markupService";

export const setLabelPax = (arrayHotel) => {
  // Determinar la estructura del array
  const isNewFormat =
    arrayHotel?.length > 0 && arrayHotel[0].hasOwnProperty("room");

  // Sumar adultos y menores según el formato
  let sumAdults = arrayHotel?.reduce(
    (acumulador, actual) =>
      acumulador + (isNewFormat ? actual.adults : actual.num_adultos),
    0
  );

  let sumKids = arrayHotel?.reduce(
    (acumulador, actual) =>
      acumulador + (isNewFormat ? actual.minors : actual.num_menores),
    0
  );

  // Generar etiquetas
  let roomLabel = arrayHotel?.length > 1 ? "Habs" : "Hab";
  let adultsLabel = sumAdults > 1 ? "A" : "A";
  let kidsLabel = sumKids === 1 ? "M" : "M";

  return `${arrayHotel?.length} ${roomLabel}, ${sumAdults} ${adultsLabel}, ${sumKids} ${kidsLabel}`;
};

export const setLabelPersonsPax = (arrayAct) => {
  // Determinar la estructura del array
  const isNewFormat =
    arrayAct.length > 0 && arrayAct[0].hasOwnProperty("adults");
  // Sumar adultos y menores según el formato
  let sumAdults = arrayAct.reduce(
    (acumulador, actual) =>
      acumulador + (isNewFormat ? actual.adults : actual.num_adultos),
    0
  );

  let sumKids = arrayAct.reduce(
    (acumulador, actual) =>
      acumulador + (isNewFormat ? actual.minors : actual.num_menores),
    0
  );

  // Generar etiquetas
  let adultsLabel = sumAdults > 1 ? "A" : "A";
  let kidsLabel = sumKids === 1 ? "M" : "M";

  return `${sumAdults} ${adultsLabel}, ${sumKids} ${kidsLabel}`;
};

export const Currency = (value, currency = "USD") => {
  let locale = "en-US";
  currency === "" && (currency = "USD");

  const formattedValue = new Intl.NumberFormat(locale, {
    currency: currency,
    style: "currency",
  }).format(value);

  return formattedValue;
};

export const fetchMarkup = async (markupHotAct) => {
  try {
    const response = await getMarkup(markupHotAct);
    return response;
  } catch (error) {
    console.error("Error fetching rates:", error);
    return [];
  }
};

export const totalPrices = (sellingRate, markup, nights, comisionCliente) => {
  let rate = Math.round(sellingRate * (1 + markup / 100));
  let ratePerNight = Math.floor(rate / nights);
  if (comisionCliente > 0 || comisionCliente !== undefined) {
    rate = rate * (1 - comisionCliente / 100);
    ratePerNight = ratePerNight * (1 - comisionCliente / 100);
  }

  return [ratePerNight, rate];
};

export const FormatCancellationPolicies = (isoString) => {
  const date = new Date(isoString);

  const day = isoString?.split("T")[0].split("-")[2]; // Día del mes
  const monthNames = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];
  const month = monthNames[date.getMonth()]; // Nombre del mes
  const year = date.getFullYear(); // Año completo
  const hours = isoString?.split("T")[1]; // Horas

  return `${day} de ${month} del ${year} a las ${hours}`;
};

export const FormatDate = (isoString) => {
  const date = new Date(isoString + "T00:00:00Z");
  const day = date.getUTCDate();

  const monthNames = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];

  const month = monthNames[date.getUTCMonth()];
  const year = date.getUTCFullYear();

  return `${day} de ${month} del ${year}`;
};

export const FormatHours = (isoString) => {
  const hours = isoString?.split(":"); // Horas
  const formatHour = hours?.[0] % 12;
  const hour = formatHour ? formatHour : 12;
  const pmAm = hours?.[0] >= 12 ? "PM" : "AM";
  return `${hour}:${hours?.[1]} ${pmAm}`;
};

export const calculateBookingDates = () => {
  const today = new Date();

  // Check-in: 5 días desde hoy
  const checkIn = new Date(today);
  checkIn.setDate(today.getDate() + 5);

  // Check-out: 3 días después del check-in
  const checkOut = new Date(checkIn);
  checkOut.setDate(checkIn.getDate() + 3);

  // Formatear las fechas a yyyy-mm-dd
  const formatDate = (date) => date.toISOString().split("T")[0];

  return {
    checkIn: formatDate(checkIn),
    checkOut: formatDate(checkOut),
  };
};

export const FormatCancellationPoliciesAct = (isoString) => {
  const date = new Date(isoString);

  const day = isoString?.split("T")[0].split("-")[2]; // Día del mes
  const monthNames = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];
  const month = monthNames[date.getMonth()]; // Nombre del mes
  const year = date.getFullYear(); // Año completo
  const twelveHours = isoString?.split("T")[1];
  const hours = twelveHours?.split(":")[0]; // Horas
  const period = hours > 12 ? "PM" : "AM";
  return `${day} de ${month} del ${year} a las ${
    hours === "00" ? "12" : hours
  }:00 ${period}`;
};

export const FormatPhoneNumber = (phone) => {
  const digits = phone.toString().replace(/\D/g, ""); // Remove non-numeric characters
  if (digits.length === 0) return ""; // No input yet
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 11)}`;
};

export const locale = {
  rangeSeparator: " a ",
  firstDayOfWeek: 1,
  weekdays: {
    shorthand: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
    longhand: [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
    ],
  },
  months: {
    shorthand: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Оct",
      "Nov",
      "Dic",
    ],
    longhand: [
      "Enero",
      "Febrero",
      "Мarzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
  },
};
